import { useField, useFormikContext } from 'formik';
import ReactQuill from 'react-quill';

const FormikReactQuill = ({ name, label, disabled }) => {
  const [field, meta] = useField(name);
  const { setFieldValue } = useFormikContext();

  return (
    <div className="form-group">
      {label && <label>{label}</label>}
      <ReactQuill
        value={field.value}
        onChange={(val) => setFieldValue(name, val)}
        readOnly={disabled}
        theme="snow"
      />
      {meta.touched && meta.error && (
        <div className="error" style={{ color: 'red' }}>{meta.error}</div>
      )}
    </div>
  );
};

export default FormikReactQuill;
